import React from "react";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { formatMoneda } from "./utils";

/**
 * Confirmación explícita cuando las retenciones absorben el importe a pagar.
 * Al aceptar, la generación se reenvía con confirmar_advertencias: true.
 */
const ModalRetencionExcedePago = ({
  open,
  onClose,
  onConfirmar,
  generando = false,
  mensaje = "",
  advertencias = [],
  excedente = 0,
  totalAPagar = null,
}) => (
  <Dialog open={open} onClose={generando ? undefined : onClose} maxWidth="sm" fullWidth>
    <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <WarningAmberIcon color="warning" />
      Las retenciones superan el importe a pagar
    </DialogTitle>
    <DialogContent dividers>
      <Typography variant="body2" sx={{ mb: 2 }}>
        {mensaje ||
          "El total de retenciones calculadas es mayor al importe de esta orden de pago."}
      </Typography>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 2,
        }}
      >
        <Typography variant="body2" color="text.secondary">
          Queda a favor de la empresa
        </Typography>
        <Typography variant="h6" fontWeight={700} color="warning.main">
          {formatMoneda(excedente)}
        </Typography>
      </Box>

      {totalAPagar != null ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Typography variant="body2" color="text.secondary">
            Total neto de la orden
          </Typography>
          <Typography variant="body2" fontWeight={600}>
            {formatMoneda(totalAPagar)}
          </Typography>
        </Box>
      ) : null}

      {advertencias.length > 0 ? (
        <>
          <Divider sx={{ my: 1.5 }} />
          <List dense disablePadding>
            {advertencias.map((msg, i) => (
              <ListItem key={i} disableGutters sx={{ py: 0.25 }}>
                <ListItemText
                  primary={msg}
                  primaryTypographyProps={{ variant: "body2" }}
                />
              </ListItem>
            ))}
          </List>
        </>
      ) : null}

      <Alert severity="info" sx={{ mt: 2 }}>
        Si continúa, la orden se genera sin transferencia al proveedor: la
        imputación a las facturas se hace por el importe bruto y las retenciones
        se emiten igual.
      </Alert>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} disabled={generando}>
        Cancelar
      </Button>
      <Button
        variant="contained"
        color="warning"
        onClick={onConfirmar}
        disabled={generando}
        startIcon={
          generando ? <CircularProgress size={18} color="inherit" /> : null
        }
      >
        Generar igual
      </Button>
    </DialogActions>
  </Dialog>
);

export default ModalRetencionExcedePago;
